import React from "react";

export function ShowNotify({ countNotify }) {
  return (
    <div
      className={`${
        countNotify === null || isNaN(countNotify) || countNotify === 0 ? "hidden" : ""
      }bg-[#F95057] min-w-[14px] max-h-[14px] text-center text-10 h-fit absolute right-0 translate-x-[40%] translate-y-[-40%] rounded sarabun text-white px-[2px] pb-[1px]`}
    >
      <div>{countNotify === null || isNaN(countNotify) ? "" : countNotify}</div>
    </div>
  );
}
